import React from "react";
import { useHistory } from "react-router-dom";
import Styles from "./OverviewTable.module.scss";
import { ReactComponent as RightArrow } from "../../assets/images/arrow-chevron-right.svg";

interface propTypes {
  preTitle?: string;
  title: string;
  subTitle?: string;
  children?: React.ReactNode;
  path?: React.ReactNode;
  route?: any;
}

export default function OverviewTable({
  preTitle,
  title,
  children,
  subTitle,
  route,
  path,
}: propTypes) {
  const history = useHistory();
  return (
    <div className={Styles.container}>
      <div className={Styles.header}>
        <div>
          <span className={Styles.headerSpan} style={{ display: "block" }}>
            {preTitle}
          </span>
          <span className={Styles.headerh2}>{title}</span>
          <span className={Styles.headerSpan}>{subTitle}</span>
        </div>
        {path && route && (
          <div
            className={Styles.path}
            onClick={() => {
              history.push(route);
            }}
          >
            {path}
            <RightArrow />
          </div>
        )}
      </div>
      <div className={Styles.tableContent}>{children}</div>
    </div>
  );
}
